import { inject, Injectable } from '@angular/core';
import { Dialog, DialogConfig } from '@angular/cdk/dialog';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalsService {
  // MOVED from MatDialog to CdkDialog
  private dialog = inject(Dialog);

  async openModal(component: any, data?: DialogConfig, desktopWidth?: string) {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const defaultDesktopWidth = desktopWidth || '450px';

    const dialogRef = this.dialog.open<any>(component, {
      width: isMobile ? '96vw' : defaultDesktopWidth,
      maxWidth: isMobile ? '96vw' : '90vw',
      ...(data as any),
    });

    return await firstValueFrom(dialogRef.closed);
  }
}
